import { ApiService } from "./apiService";
import authService from "./authService";

class LoginService extends ApiService {

    constructor() {
        super("token")
    }

    login(usuario: string, password: string) {

        const PASSWORD = "password"
        const data = `grant_type=${PASSWORD}&username=${usuario}&${PASSWORD}=${password}`

        return this.post(data, false)
            .then(res => {
                authService.guardarToken(res.access_token)
                return res
            })
    }
}

export default new LoginService()